<template>
    <v-main>
        <v-container style="background-color: #FFF;">
            <Lbls>@/src/views/myathletes/Lists.vue</Lbls>
            <v-row>
                <v-col cols="12" class="py-0">
                    <v-icon large>{{icons.group}}</v-icon>
                    <v-btn-toggle>
                        <v-btn small text @click="dialog=true, name=''">
                            <span class="hidden-xs-only">Add</span>
                            <v-icon>{{icons.plus}}</v-icon>
                        </v-btn>
                        <v-btn small v-if="dev" :dark="comparegroups" elevation="0" @click="compared=[],comparegroups=!comparegroups">cmpr</v-btn>

                    </v-btn-toggle>
                    <InvoiceToGroup />
                </v-col>
            </v-row>
            <v-row>
                <v-expand-transition duration="500">
                    <v-col :cols="cols[0]">
                        <v-list dense class="py-0 hidden-md-and-up">
                            <v-fade-transition v-if="(selectedprofiles && selectedprofiles.length) && !editstate"
                                               mode="in-out" duration="500">
                                <v-list-item
                                        :disabled="appendliststate"
                                        @click="initialize('selected'),getAthleteList({data:selectedprofiles,id:'selected'})">
                                    <v-list-item-content>
                                        <v-list-item-title :class="{'primary--text':activegroup.id==='selected'}">
                                            Currently Selected
                                            ({{selectedprofiles.length}})
                                        </v-list-item-title>
                                        <v-list-item-subtitle :class="{'primary--text':activegroup.id==='selected'}">
                                            Click
                                            view selected profiles
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon :loading="loading==='selected'">
                                            <v-icon :class="{'primary--text':activegroup.id==='selected'}">{{icons.list}}
                                            </v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-fade-transition>
                            <v-list-item @click="colsopen=!colsopen">
                                <v-list-item-content>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon v-if="!colsopen">{{icons.arrowright}}</v-icon>
                                        <v-icon v-else>{{icons.arrowleft}}</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        <GroupListMultiSelect :groups="mylists" v-if="comparegroups" @click="setComparedGroups($event)" dense />
                        <GroupList v-else :groups="mylists" @click="listClickHandler($event)" dense :active="activegroup.id" />
                    </v-col>
                </v-expand-transition>

                <v-col :cols="cols[1]" v-if="!comparegroups">
                    <v-btn-toggle  class="mr-2" v-if="activegroup.id">
                        <v-btn :text="!listeditstate" small color="awesome" elevation="0"
                               @click="listeditstate=!listeditstate">
                            <v-icon small :color="listeditstate?'white':''">{{icons.ban}}</v-icon>
                        </v-btn>
                        <v-btn :text="!dialog" small color="awesome" elevation="0" @click="dialog=true">
                            <v-icon small :color="dialog?'white':''">mdi-format-text</v-icon>
                        </v-btn>
                        <v-btn small text @click="checkPaymentStatus()" >$</v-btn>
                        <v-btn small text @click="recruitingList()">Recrt</v-btn>
                    </v-btn-toggle>
                    <span class="font-weight-light">{{actiontitle}}</span>
                    <v-list tile>
                        <v-list-item v-if="activegroup.id==='selected'"
                                     style="background-color: #0D47A188"
                        >
                            <v-list-item-action>
                                <v-list-item-action-text>
                                    <v-icon :class="{'blob':appendliststate,'white--text':true}">
                                        {{icons.arrowleft}}
                                    </v-icon>
                                </v-list-item-action-text>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="white--text">Selected: {{items.length}}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <span class="white--text">Move to list</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn text @click="appendliststate=false,setSelectedProfiles(undefined),initialize()">
                                    <v-icon class="white--text">{{icons.ban}}</v-icon>
                                </v-btn>
                                <v-list-item-action-text class="white--text">
                                    Clear Selected
                                </v-list-item-action-text>
                            </v-list-item-action>
                        </v-list-item>
                        <PlayerListItem v-for="p in items"
                                        :class="{'fadeout': removing===p.partkey,'my-0':true}"
                                        :profile="p"
                                        :islink="!listeditstate"
                                        :loading="removeingloading"
                                        @selected="handleProfileClick($event)"
                                        :style="`${listeditstate?'border: solid thin #888888;':''}`"
                        />
                        <v-btn  @click="mdialog=true">Message Group</v-btn>
                    </v-list>
                </v-col>
            </v-row>
            <v-row v-if="comparegroups">
                <v-col cols="12" class="py-0">
                    <v-btn :text="!findingdupes" small @click="findingdupes=!findingdupes,findDupes()">Dupes</v-btn>
                </v-col>
                <v-col v-for="items in compared">
                    {{items.group.name}}
                    <PlayerListItem v-for="p in items.profiles"
                                    :profile="p"
                                    :islink="!listeditstate"
                                    :loading="removeingloading"
                                    @selected="handleProfileClick($event)"
                                    :active="dupes.includes(p.partkey)"
                                    :style="`${listeditstate?'border: solid thin #888888;':''}`"
                    />
                </v-col>
            </v-row>

        </v-container>

        <v-dialog v-model="dialog" max-width="400" persistent>
            <v-card>
                <v-card-title>
                    <span v-if="activegroup.id" class="pr-1">Edit </span><span class="pr-1" v-else>Add </span>
                    Group
                </v-card-title>
                <v-card-text>
                    <v-text-field outlined v-model="activegroup.name"/>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="dialog=false,saving=false">Cancel</v-btn>
                    <v-spacer/>
                    <v-btn text @click="renameList()" :loading="saving">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="mdialog" max-width="500" persistent>
            <v-card>
                <v-card-title>
                    Message
                </v-card-title>
                <v-card-text>
                    Message
                    <v-text-field dense v-model="subject" label="Subject" outlined />
                    <v-textarea outlined v-model="message"/>
                    <v-checkbox v-model="includeemail" label="Also send to email" />
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="mdialog=false,message=undefined" :disabled="sending">Cancel</v-btn>
                    <v-spacer/>
                    <v-btn text @click="messageGroup()" :disabled="message && message.length<4"  :loading="sending">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="recruitinglist" persistent fullscreen>
           <v-card>
                <v-card-title>
<!--                    {{this.activegroup.name}}-->
                    <v-btn text @click="recruitinglist=false, recruitingprofiles=[]">X</v-btn>
                </v-card-title>
                <v-card-text>
                    <v-list class="listol py-0"
                            v-for="p in recruitingprofiles">
                        <v-list-item class="my-0">
                            <v-list-item-avatar tile size="60">
                                <v-img :src="p.info.profilepic"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{p.info.firstname}} {{p.info.lastname}} GradYear  {{p.info.gradyear}}   {{p.height?getHeight(p.height):''}}

                                </v-list-item-title>
                                <v-list-item-title>
                                    {{p.info.email?p.info.email+' | ':''}} {{p.info.cell?p.info.cell+' | ':''}} {{p.info.instagram}}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-avatar tile size="60" v-if="p.committed">
                                <v-img :src="p.committed.img"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-avatar tile size="80" v-else>
                                <v-img :src="'https://api.qrserver.com/v1/create-qr-code/?data=https://volleyforlife.com/recruiting/'+p.partkey+'&size=100x100'" />
                            </v-list-item-avatar>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <router-link to="/recruitingsheet">
                        <button>Print this page</button>
                    </router-link>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import PlayerListItem from "@/views/a4l/playercomponents/PlayerListItem";
  import Lbls from "@/components/Lbls";
  import GroupList from "../../components/groups/GroupList";
  import GroupListMultiSelect from "../../components/groups/GroupListMultiSelect";
  import InvoiceToGroup from "../../components/invoicing/InvoiceToGroup";

  export default {
    name: "Lists",
    components: {InvoiceToGroup, GroupListMultiSelect, GroupList, Lbls, PlayerListItem},
    data() {
      return {
        saving: false,
        items: [],
        mylists: [],
        name: '',
        dialog: false,
        activegroup: {
          id: false,
          name: '',
          data: []
        },
        loading: false,
        appendliststate: false,
        appendedlist: false,
        editstate: false, //change to a single variable as a string value
        listeditstate: false,
        removing: false,
        removeingloading: false,
        colsopen: true,
        comparegroups: false,
        compared:[],
        dupes:[],
        findingdupes:false,
        paymentstatus:[],
        invoicecode:'v4ljan2021',
        mdialog:false,
        message:undefined,
        sending:false,
        subject: undefined,
        includeemail: false,
        recruitinglist: false,
        recruitingprofiles: []
      }
    },
    computed: {
      ...mapState(['selectedprofiles', 'icons', 'dev','sportcode']),
      ccolor() {
        return 'awesome--text text--lighten-2'
      },
      cols() {
        if (this.$vuetify.breakpoint.smAndDown && !this.colsopen) {
          return [3, 9]
        } else {
          return [6, 6]
        }
      },
      actiontitle() {
        if (this.listeditstate && this.activegroup.data.length > 0) {
          return 'Click to remove from list'
        } else if(this.activegroup.id && this.activegroup.data.length===0){
          return 'No profiles in list  "'+this.activegroup.name+'" '
        } else {
          return ''
        }
      }
    },
    created() {
      this.checkPaymentStatus()
      this.getAllLists()
      if (this.$route.query.active) {
        this.getList(this.$route.query.active)
      }
      this.setRecruitingList(this.recruitingprofiles)
    },
    methods: {
      ...mapActions(['get', 'post']),
      ...mapMutations(['setSelectedProfiles','setRecruitingList']),
      initialize(listdata) {
        console.log(listdata)
        this.activegroup = {
          id: (listdata === 'selected') ? 'selected' : false,
          name: '',
          data: listdata || []
        }
        this.items = []
      },
      listClickHandler(list) {
        if (this.appendliststate) {
          this.appendList(list)
        } else if (this.editstate) {
          this.setActiveList(list)
          this.editstate = false
          this.dialog = true
        } else if (this.activegroup.id === list.id) {
          this.initialize(false)
        } else {
          if (this.$route.query.active !== list.id.toString()) {
            this.$router.replace(this.$route.path + '?active=' + list.id)
          }
          this.setActiveList(list)
        }
      },
      handleProfileClick(profile) {
        if (this.listeditstate) {
          this.removeFromGroup(profile)
        }

      },
      appendList(l) {
        this.appendedlist = l.id
        l.data = l.data.concat(this.selectedprofiles)
        let tmp = new Set(l.data) //new Set() data Object, only allows unique values
        l.data = [...tmp]         //convert back to array
        //l.dirty=true
        this.setActiveList(l)
        this.getAthleteList(l)
        this.saveList()
        let em = this
        setTimeout(function () {
          em.appendedlist = false
          em.appendliststate = false
          em.setSelectedProfiles(undefined)
        }, 1000)
      },
      setActiveList(l) {
        this.listeditstate = false
        this.activegroup = Object.assign({}, l)
        this.getAthleteList(this.activegroup)
      },
      async getAllLists() {
        let p = await this.post({path: 'api/profilesv2/getlists', body: {}})
        this.mylists = p
      },
      async getList(id) {
        let p = await this.post({path: 'api/profilesv2/getlist/' + id, body: {data: this.list}})
        this.activegroup = p
        this.getAthleteList(p)
      },
      async getAthleteList(list) {
        let em = this
        setTimeout(function () {
          em.loading = false
        }, 5000)
        this.loading = list.id
        let rsp = await this.post({path: 'api/profilesv2/athletesbylist', body: {list: list.data, invoicecode: this.invoicecode}})
        if(this.comparegroups){
          return rsp;
        }
        console.log(rsp)
        this.items = rsp
        this.loading = false
      },
      async setComparedGroups(e){
        this.compared=[]
        for(const g of e){
          let v = await this.getAthleteList(g)
          console.log('V',v)
          this.compared.push({group:g,profiles:v})
        }
      },
      async saveList() {
        this.saving = true;
        if (this.activegroup.id === 'selected') {
          this.activegroup.id = false
        }
        let p = await this.post({path: 'api/profilesv2/savelist', body: this.activegroup})
        console.log('P', p, this.activegroup)
        this.saving = false
        this.setActiveList(this.activegroup)
        this.appendliststate = false
        this.setSelectedProfiles(undefined)
        this.getAllLists()
        this.dialog = false
      },
      async renameList() {
        this.saving = true
        if (this.activegroup.id === 'selected') {
          this.activegroup.id = false
        }
        let p = await this.post({path: 'api/profilesv2/renamelist', body: this.activegroup})
        console.log('P', p, this.activegroup)
        this.setActiveList(this.activegroup)
        this.appendliststate = false
        this.setSelectedProfiles(undefined)
        this.getAllLists()
        this.saving = false
        this.dialog = false
      },
      async removeFromGroup(profile) {
        this.removeingloading = profile.partkey
        let rsp = await this.post({
          path: 'api/profilesv2/addtogroup',
          body: {groupid: this.activegroup.id, keystoadd: [profile.partkey], action: 'remove'}
        })
        console.log(rsp)
        this.removeingloading = undefined
        let index = this.activegroup.data.findIndex(f => {
          return f === profile.partkey
        })
        this.removing = profile.partkey
        this.activegroup.data.splice(index, 1)
        index = this.mylists.findIndex(f => {
          return f.id === this.activegroup.id
        })
        this.mylists[index] = this.activegroup
        let em = this;
        setTimeout(function () {
          em.removing = false
          index = em.items.findIndex(f => {
            return f.partkey === profile.partkey
          })
          em.items.splice(index, 1)
        }, 800)
      },
      getColorClass(l) {
        if (this.activegroup.id === l.id) {
          return 'primary--text'
        } else if (this.appendliststate) {
          return this.ccolor
        } else if (this.editstate) {
          return 'success--text text--darken-1'
        } else if (l.dirty) {
          return 'warning--text'
        }
      },
      findDupes(){
        if(!this.findingdupes)return
        let checkdupes = []
        this.dupes=[]
        for(const c of this.compared){
          for(let i=0; i<c.group.data.length;i++){
            if(!checkdupes.includes(c.group.data[i])){
              checkdupes.push(c.group.data[i])
            }else{
              this.dupes.push(c.group.data[i])
            }
          }
        }
        console.log('Dupes',this.dupes)
      },
      async checkPaymentStatus(){
        let rsp = await this.get({path:'api/invoicing/invoicesbyprifilesmonth'})
        this.paymentstatus = rsp;
      },
      //note. make this a multigroup send BUT handle invoicing so that is 'Rolls up' the charges into the same invoice recipient
      async recruitingList(){
        //this.recruitinglist = true; return;
        console.log(this.items)
        let d = this.items.map(f=>{ return f.partkey })
        let rsp = await this.post({path: 'api/profilesv2/athletesrecruitinglist', body: {list: d, sport:this.sportcode}})
        console.log(rsp)
        this.recruitinglist = true;
        this.recruitingprofiles = rsp
        this.setRecruitingList(rsp)
      },
      getHeight(n){
        let feet = parseInt(n/12)
        let inch = n%12
        return feet+'\' '+inch+'"'
      },
      async messageGroup(){
        let data = {list:this.activegroup, message:this.message, subject: this.subject, includeemail: this.includeemail}
        this.sending = true;
        let res = await this.post({path:'api/profilegroups/sendtogroup',body:data});
        this.sending = false;
        this.mdialog = false;
        this.message = undefined;
        this.subject = undefined;
        this.includeemail = false;
        console.log(res)
      }
    }
  }

</script>

<style scoped>
    .listol {
        border-bottom: solid thin #888888;
    }
    .blob {
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scaleX(1.4) scaleY(1.4);
        }

        70% {
            transform: scaleX(1.1) scaleY(1.2);
        }

        100% {
            transform: scaleX(1.4) scaleY(1.5);
        }
    }

    .fadeout {
        animation: fade 3s 1;
    }

    @keyframes fade {
        0% {
            transform: scaleX(.8) scaleY(.8);
            opacity: .5;
        }

        20% {
            transform: scaleX(.1) scaleY(.1);
            opacity: 1;
            visibility: hidden;
        }
        21% {
            visibility: hidden;
        }
        100% {
            visibility: hidden;
        }
    }

</style>